import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import logo from "../../assests/Aayslogo.png";
import { Link } from "react-router-dom";
import "./Home.scss";

import { FaCheckCircle } from "react-icons/fa";
import databaseIcon from "../../assests/database.png"
import dataDomainIcon from "../../assests/datadomain.png"
import dataDiscoveryIcon from "../../assests/cloudcomputing.png"
import trafficConeIcon from "../../assests/trafficlight.png"
import monitorIcon from "../../assests/monitoring.png"
import arrowIcon1 from "../../assests/icon1.png"
import arrowIcon2 from "../../assests/icon2.png"
import arrowIcon3 from "../../assests/icon3.png"
import arrowIcon4 from "../../assests/icon4.png"
import arrowIcon5 from "../../assests/icon5.png"

const features = [
  {
    icon: databaseIcon,
    title: "Data Product",
    description:
      "Add new data products with clear ownership, documentation, and quality expectations. Each product is structured, registered, and governed for publish contract.",
    highlights: ["Clear Ownership", "Quality Standards", "Publish Contract"],
    ctaText: "Onboard Product",
    ctaColor: "bg-[#3da046] hover:bg-[#3da046]",
    path: "/Dashboard",
    hovercolor: "#bb1ccc",
    hoverLogo: "#bb1ccc",
    arrowIcon: arrowIcon1,
  },
  {
    icon: dataDomainIcon,
    title: "Data Domains",
    description:
      "Organize data into logical, business-aligned domains for clarity, ownership, and access. Domains improve discoverability and align datasets with business areas.",
    highlights: ["Business Alignment", "Improved Discovery", "Clear Structure"],
    ctaText: "Domain Overview",
    ctaColor: "bg-[#ff3c14] hover:bg-[#ff3c14]",
    path: "/dataDomain",
    hovercolor: "#bb1ccc",
    hoverLogo: "#bb1ccc",
    arrowIcon: arrowIcon2,
  },
  {
    icon: dataDiscoveryIcon,
    title: "Data Discovery",
    description:
      "Enable users to search, explore, and evaluate datasets across the platform using metadata, profiling, and lineage. Discover helps users quickly find the right data.",
    highlights: [
      "Smart Search",
      "Subscribe",
      "Lineage Tracking",
    ],
    ctaText: "Explore Data",
    ctaColor: "bg-[#9600ff] hover:bg-[#9600ff]",
    path: "/data-contract",
    hovercolor: "#bb1ccc",
    hoverLogo: "#bb1ccc",
    arrowIcon: arrowIcon3,
  },
  {
    icon: trafficConeIcon,
    title: "Traffic Lights",
    description:
      "Track and visualize data health using traffic light indicators that reflect quality status. This mechanism provides a clear, real-time view of trust levels.",
    highlights: ["Real-time Status", "Quality Indicators", "Event Driven"],
    ctaText: "Check Data Health",
    ctaColor: "bg-[#ff8200] hover:bg-[#ff8200]",
    path: "/",
    hovercolor: "#bb1ccc",
    hoverLogo: "#bb1ccc",
    arrowIcon: arrowIcon4,
  },
  {
    icon: monitorIcon,
    title: "Data Monitoring",
    description:
      "Continuously monitor pipeline performance, data availability, and usage. Monitoring ensures early issue detection, SLA adherence, and operational stability.",
    highlights: ["Performance Tracking", "Early Detection", "SLA Adherence"],
    ctaText: "Monitor Data",
    ctaColor: "bg-[#ff31a0] hover:bg-[#ff31a0]",
    path: "/data-monitoring",
    hovercolor: "#bb1ccc",
    hoverLogo: "#bb1ccc",
    arrowIcon: arrowIcon5,
  },
];

const HomePage = () => {
  return (
    <Box sx={{ position: "relative", overflow: "hidden",overflowY:"auto",height:"120vh" ,zoom:'0.75'}}>     

    {/* Foreground */}
      <Box sx={{ position: "relative", zIndex: 3, px: { xs: 3, md: 6 } }}>
        <Box className="home-container">

          {/* Logo */}
          <Typography variant="div" className="home-logo">
            <img width={80} src={logo} alt="logo" className="home-logo" />
          </Typography>

          {/* Title */}
          <div className="mb-[12px]">
          <p style={{color: "#bb1ccc"}} className="text-center text-[#bb1ccc] font-poppins text-[40px] sm:text-[50px] md:text-[60px] lg:text-[80px] font-bold leading-[1.1] bg-gradient-to-r from-[#0F0791] to-[#3EC9F7] bg-clip-text text-transparent">
          Aays{/* Aays Data <br /> */} Data <br/>
           Marketplace
        </p> 
        
        </div>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4 w-full max-w-[100%] mx-auto mt-4 mb-[40px] px-4">
            <div className="hidden sm:block w-[296px] h-[4px] bg-[#bb1ccc]" ></div>
            <div className="text-center font-poppins text-[24px] sm:text-[30px] md:text-[36px] font-normal text-[#424242] flex-shrink-0 px-2"> Your real-time heartbeat of data health!</div>
            <div className="hidden sm:block w-[296px] h-[4px] bg-[#bb1ccc]" ></div>
          </div>

           {/* Feature Grid */}
           <div className="card-grid">
             {features.map((feature, index) => (
              <Link to={feature.path} key={index}>
              
                <div 
                  key={index} 
                  className="group rounded-2xl shadow-lg flex flex-col h-[385px] w-[280px] sm:w-[296px] transition-all duration-300 ease-in-out font-poppins cursor-pointer relative "
                  style={{
                    '--hover-color': feature.hovercolor,
                    '--cta-bg': feature.hovercolor,
                    '--cta-text': 'white',
                    border: '1px solid black',
                    // clipPath: 'polygon(0% 0%, 100% 0%, 100% 85%, 90% 100%, 0% 100%)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = feature.hovercolor;
                    e.currentTarget.style.setProperty('--cta-bg', 'white');
                    e.currentTarget.style.setProperty('--cta-text', 'black');
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '';
                    e.currentTarget.style.setProperty('--cta-bg', feature.hovercolor);
                    e.currentTarget.style.setProperty('--cta-text', 'white');
                  }}
                >
                {/* Icon */}

                <div className="px-4">
                  <Link to={feature.path} >
                <div
                className="flex items-center justify-center w-[40px] h-[45px] rounded-xl mb-[22px] mt-[37px] group hover:text-black transition-colors duration-300"
              >
                <img src={feature.icon} alt="icon"  className="w-[40px] h-[45px] filter group-hover:invert group-hover:brightness-200 transition duration-300" />
              </div>
              </Link>


                 {/* Title + Info */}
                 <div className="flex gap-2 mb-[6px] items-center">
                   <h3 className="text-[24px] font-poppins font-semibold text-[#424242] group-hover:text-white transition-colors duration-300">{feature.title}</h3>
                 </div>

                 {/* Highlights */}
                 <div className="space-y-2 mb-6 ">
                   {feature.highlights.map((highlight, idx) => (
                     <div
                       key={idx}
                       className="flex justify-start text-gray-500 gap-2 items-center"
                     >
                       <FaCheckCircle style={{ fontSize: "15px" }} className="text-[#bb1ccc] group-hover:text-white transition-colors duration-300" />
                       <span className="text-[#000] text-[20px] font-normal group-hover:text-white transition-colors duration-300">{highlight}</span>
                     </div>
                   ))}
                 </div>

                 </div>

                {/* CTA */}
                <div className="mt-auto relative">
                  <Link to={feature.path} className="block w-full">
                    <div
                      className="w-full py-3 px-4 rounded-b-xl   flex items-center "
                      style={{ 
                        backgroundColor: 'var(--cta-bg)',
                        color: 'var(--cta-text)'
                      }}
                    >
                      <span className="font-bold tracking-wide text-[20px] font-bold  font-poppins">
                        {feature.ctaText}
                      </span>

                    </div>

                     <div className="absolute bottom-[-1px] right-[-1px]">
                      <img src={feature.arrowIcon} alt="icon"  className="h-[59px] bg-transparent" />

                     </div>


                  </Link>
                </div>
              </div>
              </Link>
            ))}
            
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default HomePage;
